import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ADMINS_GIS_FILES_PATH } from '../../utils/constants';
import { GisFilesList } from './components/GisFilesList/GisFilesList';

export const GisFiles = () => {
  return (
    <Switch path={ADMINS_GIS_FILES_PATH}>
      <Route exact path={ADMINS_GIS_FILES_PATH} component={GisFilesList} />
    </Switch>
  );
};
